/* TDP - Signaletique (section tdp-sig-carousel) : carrousel de projets.
   Navigation 100% manuelle : un seul index actif, change uniquement au clic
   sur une fleche ou une barre. Aucun minuteur, aucun defilement automatique.
   Repris du script qui etait dans le contenu de la page. Le glissement au
   doigt et l'effet de page qui glisse restent dans tdp-pages.js.
   Charge en defer : s'execute avant DOMContentLoaded, donc avant tdp-pages.js
   qui lit la slide active a ce moment-la (comme avec l'ancien script). */
(function () {
  'use strict';

  function init(scope) {
    scope.querySelectorAll('[data-tdp-sg-carousel]').forEach(function (wrap) {
      if (wrap.dataset.tdpSgReady) return;
      wrap.dataset.tdpSgReady = '1';
      var root = wrap.querySelector('.tdp-sg-carousel');
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.tdp-sg-carousel-slide'));
      var bars = Array.prototype.slice.call(wrap.querySelectorAll('.tdp-sg-carousel-bar'));
      var prevBtn = root.querySelector('.tdp-sg-carousel-arrow--prev');
      var nextBtn = root.querySelector('.tdp-sg-carousel-arrow--next');
      var n = slides.length;
      if (!n) return;

      var activeIndex = 0;

      function setActive(target) {
        activeIndex = ((target % n) + n) % n;
        slides.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === activeIndex);
        });
        bars.forEach(function (b, idx) {
          b.classList.toggle('is-active', idx <= activeIndex);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(activeIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(activeIndex + 1); });
      bars.forEach(function (b, idx) {
        b.addEventListener('click', function () { setActive(idx); });
      });

      setActive(0);
    });
  }

  init(document);
  // Editeur de theme : section rechargee ou bloc selectionne.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.tdp-sg-carousel-slide');
    var wrap = e.target.closest('[data-tdp-sg-carousel]');
    if (!slide || !wrap) return;
    var bars = wrap.querySelectorAll('.tdp-sg-carousel-bar');
    var idx = Array.prototype.indexOf.call(wrap.querySelectorAll('.tdp-sg-carousel-slide'), slide);
    if (bars[idx]) bars[idx].click();
  });
})();
